export default "__VITE_ASSET__21ac09e8__"